import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import * as dates from '@simplybenefits/sb-dates';
import FormControl from '@mui/material/FormControl';
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { TextInput, DateInput, Button, Services, Text, FormModal, BubbleSelectBlock, Loader, Container, ContentSmall, Title, Theme, Checkbox, i18n, tokens, localizationMaps } from '@simplybenefits/sb-ui-library';

import PersonBlock from './PersonBlock';
import { addDependent, editDependent, removeDependent } from '../../actions/user';
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

const insuranceOptions = [
    'Simply Benefits',
    'Desjardins',
    'Great-West Life',
    'Green Shield',
    'Manulife',
    'Pacific Blue Cross',
    'RBC Insurance',
    'RWAM',
    'SSQ',
    'Sun Life',
    'The Co-operators',
    'Other'
];

class Dependents extends PureComponent {
    state = {
        firstname: '',
        lastname: '',
        gender: '',
        birthdate: '',
        cohabDate: '',
        relationship: '',
        email: '',
        employer: '',
        insuranceCarrier: '',
        dependentCertNumber: '',
        spouseCoverage: null,
        dependents: null,
        dialogOpen: false,
        isEdit: false,
        hasSpouse: false,
        options: Services.selectFieldOptions.dependentOptionsWithoutSpouse(),
        dependentID: null,
        ageDisclaimer: false,
        confirmPasswordModalOpen: false,
        dependentToRemoveID: false,
        password: '',
        visibility: false,
        signage: {
            name: '',
            signature: '',
            acceptedTerms: false,
            timestampOfAcceptance: null,
            datedOn: null
        }
    };

    async componentDidMount() {
        await this.props.dependents.some((dependent) => {
            if (dependent.relationship === 'Spouse') {
                this.setState({
                    hasSpouse: dependent.dependentID
                });

                return true;
            }

            return false;
        });
    }

    _close = () => {
        this.setState({
            firstnameError: null,
            lastnameError: null,
            emailError: null,
            genderError: null,
            relationshipError: null,
            sharesError: null,
            passwordError: null,
            dialogOpen: false,
            dependentToRemoveID: false,
            signage: {
                name: '',
                signature: '',
                acceptedTerms: false,
                timestampOfAcceptance: null,
                datedOn: null
            }
        });
    };

    _handleSelectChange = (type, event, id) => {
        if (event.target.value === 'Spouse') {
            this.setState({
                hasSpouse: id
            });
        }

        this._handleInputChange(type, event);
    };

    _handleSignageChange = (type, value) => {
        if (type === 'acceptedTerms' && value === true) {
            this.setState({
                signage: {
                    ...this.state.signage,
                    acceptedTerms: true,
                    timestampOfAcceptance: dates.getUTC()
                }
            });

            return null;
        }

        this.setState({
            signage: {
                ...this.state.signage,
                [type]: value
            }
        });

        return null;
    };

    _onBlur = async (type) => {
        this.setState({
            [`${ type }Error`]: await Services.validateInput(type, this.state[type])
        });
    };

    _handleInputChange = (type, event) => {
        this.setState({
            [type]: event.target.value.toString()
        });
    };

    _validateForm = async () => {
        const firstnameError = await Services.validateInput('firstname', this.state.firstname);
        const lastnameError = await Services.validateInput('lastname', this.state.lastname);
        const genderError = await Services.validateInput('gender', this.state.gender);
        const birthdateError = await Services.validateInput('birthdate', this.state.birthdate);
        const cohabDateError = localizationMaps.toEnglish("relationships", this.state.relationship).toUpperCase() === 'COMMON LAW' ? await Services.validateInput('relationship', this.state.cohabDate) : false;
        const relationshipError = await Services.validateInput('relationship', this.state.relationship);
        const emailError = (!this.state.email || this.state.email === '') ? false : await Services.validateInput('email', this.state.email || '');

        let employerError = false;
        let insuranceCarrierError = false;
        let dependentCertNumberError = false;

        if (this.state.spouseCoverage === true) {
            employerError = await Services.validateInput('checkEmpty', this.state.employer || '');
            insuranceCarrierError = await Services.validateInput('checkEmpty', this.state.insuranceCarrier || '');
            dependentCertNumberError = await Services.validateInput('checkEmpty', this.state.dependentCertNumber || '');
        }

        this.setState({
            firstnameError,
            lastnameError,
            emailError,
            genderError,
            birthdateError,
            cohabDateError,
            relationshipError,
            employerError,
            insuranceCarrierError,
            dependentCertNumberError
        });

        if (
            firstnameError ||
            lastnameError ||
            emailError ||
            genderError ||
            birthdateError ||
            cohabDateError ||
            relationshipError ||
            employerError ||
            insuranceCarrierError ||
            dependentCertNumberError
        ) {
            return false;
        }

        const isValid = await this._ageValidation();

        if (isValid) {
            return this._showConfirmPasswordDialog();
        }

        return false;
    };

    _add = () => {
        let options = Services.selectFieldOptions.dependentOptionsWithoutSpouse();

        if (!this.state.hasSpouse) {
            options = Services.selectFieldOptions.dependentOptionsWithSpouse();
        }

        this.setState({
            firstname: '',
            lastname: '',
            email: '',
            gender: '',
            birthdate: '',
            cohabDate: '',
            relationship: '',
            employee: '',
            insuranceCarrier: '',
            dependentCertNumber: '',
            spouseCoverage: null,
            isEdit: false,
            firstnameError: false,
            lastnameError: false,
            emailError: false,
            birthdateError: false,
            cohabDateError: false,
            relationshipError: false,
            ageDisclaimer: false,
            dialogOpen: true,
            confirmPasswordModalOpen: false,
            dependentToRemoveID: false,
            options,
            password: '',
            signage: {
                name: '',
                signature: '',
                acceptedTerms: false,
                timestampOfAcceptance: null,
                datedOn: null
            }
        });
    };

    _edit = async (dependent) => {
        let options = Services.selectFieldOptions.dependentOptionsWithoutSpouse();

        if (!this.state.hasSpouse || this.state.hasSpouse === dependent.dependentID) {
            options = Services.selectFieldOptions.dependentOptionsWithSpouse();
        }

        await this.setState({
            dependentID: dependent.dependentID,
            firstname: dependent.firstname,
            lastname: dependent.lastname,
            email: dependent.email || '',
            gender: dependent.gender,
            birthdate: Services.dates.formatIncomingDate(dependent.birthdate),
            cohabDate: dependent.cohabDate === '' ? null : Services.dates.formatIncomingDate(dependent.cohabDate),
            relationship: dependent.relationship,
            employer: dependent.employer,
            insuranceCarrier: dependent.insuranceCarrier,
            dependentCertNumber: dependent.cert,
            spouseCoverage: dependent.relationship.toLowerCase() === 'spouse' ? Boolean(this.props.user.coverageThroughSpouse) : null, // only use the coverageThroughSpouse flag if they are the spouse dependent
            isEdit: true,
            dialogOpen: true,
            ageDisclaimer: false,
            confirmPasswordModalOpen: false,
            dependentToRemoveID: false,
            firstnameError: false,
            lastnameError: false,
            emailError: false,
            birthdateError: false,
            cohabDateError: false,
            relationshipError: false,
            options,
            password: '',
            signage: {
                name: '',
                signature: '',
                acceptedTerms: false,
                timestampOfAcceptance: null,
                datedOn: null
            }
        });
    };

    _toggleVisibility = () => {
        this.setState({
            visibility: !this.state.visibility
        });
    };

    /**
     * Called on save dependent
     * @private
     */
    _ageValidation = () => {
        const { birthdate, relationship } = this.state;
        // Calculate age in years
        const age = moment().utc()
            .diff(birthdate, 'years');

        if (age > 25 && (relationship === 'Child' || relationship === 'grandchild')) {
            this.setState({
                birthdateError: i18n.t(tokens.labels.resources.dependentsAgeLimit)
            });

            return false;
        }

        if (age > 20 && age < 26 && (relationship.toLowerCase() === 'child' || relationship.toLowerCase() === 'grandchild')) {
            this.setState({
                ageDisclaimer: true
            });

            return false;
        }

        return true;
    };

    _showConfirmPasswordDialog = (dependentToRemoveID = false) => {
        this.setState({
            dialogOpen: true,
            ageDisclaimer: false,
            confirmPasswordModalOpen: !this.state.confirmPasswordModalOpen,
            dependentToRemoveID
        });
    };

    /**
     * Called after age validation
     * @private
     */
    _save = async () => {
        const { firstname, lastname, gender, birthdate, cohabDate, relationship, dependentID, email, employer, insuranceCarrier, dependentCertNumber, spouseCoverage, password, signage } = this.state;

        // check if the password was provided
        const passwordError = await Services.validateInput('password', password);
        this.setState({ passwordError });

        if (passwordError) {
            return false;
        }

        let success = false;
        const data = {
            firstname,
            lastname,
            gender,
            birthdate: Services.dates.formatOutgoingDate(birthdate),
            cohabDate: cohabDate === '' ? null : Services.dates.formatOutgoingDate(cohabDate),
            relationship,
            employer: employer === '' ? null : employer,
            insuranceCarrier: insuranceCarrier === '' ? null : insuranceCarrier,
            dependentCertNumber: dependentCertNumber === '' ? null : dependentCertNumber,
            spouseCoverage: null,
            password,
            signage: {
                ...signage,
                datedOn: Services.dates.formatOutgoingDate(this.state.signage.datedOn)
            }
        };

        if (email && email.length > 0) {
            data.email = email;
        }

        if (spouseCoverage !== null && spouseCoverage !== undefined) {
            data.spouseCoverage = spouseCoverage;
        }

        if (this.state.isEdit) {
            success = await this.props.dispatch(editDependent(dependentID, data));
        } else {
            success = await this.props.dispatch(addDependent(data));
        }

        if (success) {
            this.setState({
                isEdit: false,
                dialogOpen: false,
                confirmPasswordModalOpen: false,
                signage: {
                    name: '',
                    signature: '',
                    acceptedTerms: false,
                    timestampOfAcceptance: null,
                    datedOn: null
                }
            });

            if (relationship !== 'Spouse') {
                this.setState({
                    hasSpouse: false
                });
            }

            return true;
        }

        return false;
    };

    _validateSignageBlock = async () => {
        const { signage, password } = this.state;

        const passwordError = await Services.validateInput('checkEmpty', password);
        let signageNameError = await Services.validateInput('checkEmpty', signage.name);
        const signageSignatureError = await Services.validateInput('checkEmpty', signage.signature);
        const signageDatedOnError = await Services.validateInput('date', signage.datedOn, i18n.locale);
        const signageAcceptedError = !signage.acceptedTerms;

        if (signageAcceptedError) {
            alert(i18n.t(tokens.labels.signage.pleaseAcceptAndAcknowledgeChanges));
            return null;
        }

        if (signage.name !== signage.signature) {
            signageNameError = i18n.t(tokens.labels.signage.signageNameError);
        }

        this.setState({
            signageNameError,
            signageSignatureError,
            signageDatedOnError,
            passwordError
        });

        if (
            signageNameError ||
            signageSignatureError ||
            signageDatedOnError ||
            passwordError
        ) {
            return false;
        }

        return true;
    };

    _remove = async () => {
        const isSignageValid = await this._validateSignageBlock();

        if (!isSignageValid) {
            return null;
        }

        const signage = {
            ...this.state.signage,
            datedOn: Services.dates.formatOutgoingDate(this.state.signage.datedOn)
        };

        const success = await this.props.dispatch(removeDependent(
            this.state.dependentToRemoveID,
            this.state.password,
            signage
        ));

        if (success) {
            this.setState({
                dependentToRemoveID: false,
                dialogOpen: false
            });
        }

        return null;
    };

    render() {
        const { dependents, whitelabel } = this.props;
        const signatureStyle = {
            fontFamily: 'AntaraDistance !important',
            fontWeight: 'bold',
            fontSize: 20,
            paddingBottom: 0
        };

        return (
            <Container>
                <ContentSmall style={{ width: "60%" }}>
                    <Title title={ i18n.t(tokens.titles.dependents) } />

                    {
                        dependents.length === 0 ?
                            <Text testid="dependents" light medium>{ i18n.t(tokens.labels.account.noDefinedDependents) }</Text>
                            :
                            dependents.map((dependent, i) => (
                                <PersonBlock
                                    testid={i === 0 ? "dependents" : undefined}
                                    key={dependent.dependentID}
                                    firstname={dependent.firstname}
                                    lastname={dependent.lastname}
                                    relationship={dependent.relationship}
                                    parentID={dependent.parentID}
                                    type="dependent"
                                    status={dependent.status === 'Active' ? 'Active' : dependent.termDate ? 'Terminated' : 'Disabled'}
                                    edit={() => this._edit(dependent)}
                                    remove={() => this._showConfirmPasswordDialog(dependent.dependentID)}
                                />
                            ))
                    }

                    <FormModal
                        testid="add-edit-dependent-modal"
                        open={ this.state.dialogOpen }
                        close={ this._close }
                        title={ this.state.confirmPasswordModalOpen ? i18n.t(tokens.titles["confirm changes"]) : this.state.isEdit ? i18n.t(tokens.titles["edit dependent"]) : i18n.t(tokens.titles["add dependent"]) }
                        disableBackdropClick
                        disableEscapeKeyDown
                    >
                        {
                            this.state.ageDisclaimer &&
                                <React.Fragment>
                                    <Text
                                        align="left"
                                        small
                                        display="inline-block"
                                    >
                                        { i18n.t(tokens.labels.account.confirmDependentStudentStatus) }
                                    </Text>

                                    <Button
                                        onClick={() => this._showConfirmPasswordDialog(false)}
                                        marginTop={40}
                                        color="primary"
                                        fullWidth
                                    >
                                        { i18n.t(tokens.buttons.confirm) }
                                    </Button>
                                </React.Fragment>
                        }

                        {
                            this.state.confirmPasswordModalOpen &&
                                <React.Fragment>
                                    <Text
                                        align="left"
                                        medium
                                        display="inline-block"
                                    >
                                        { i18n.t(tokens.labels.account.confirmDependentChanges)}
                                    </Text>

                                    <TextInput
                                        label={ i18n.t(tokens.labels.password) }
                                        value={this.state.password}
                                        inputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    {
                                                        this.state.visibility ?
                                                            <VisibilityIcon
                                                                style={{ cursor: "pointer", color: Theme.colors.darkGrey }}
                                                                onClick={this._toggleVisibility}
                                                            />
                                                            :
                                                            <VisibilityOffIcon
                                                                style={{ cursor: "pointer", color: Theme.colors.darkGrey }}
                                                                onClick={this._toggleVisibility}
                                                            />
                                                    }
                                                </InputAdornment>
                                            )
                                        }}
                                        onBlur={() => this._onBlur('password')}
                                        onChange={(value) => this._handleInputChange('password', value)}
                                        error={Boolean(this.state.passwordError)}
                                        helperText={this.state.passwordError}
                                        secure={!this.state.visibility}
                                        fullWidth
                                        autofocus
                                    />

                                    { /* SIGNAGE BLOCK HERE */ }

                                    <TextInput
                                        label={ i18n.t(tokens.labels.yourName)}
                                        fullWidth
                                        value={this.state.signage.name}
                                        onChange={(e) => this._handleSignageChange('name', e.target.value)}
                                        error={ this.state.signageNameError }
                                    />

                                    <TextInput
                                        label={ i18n.t(tokens.labels.signature) }
                                        fullWidth
                                        value={this.state.signage.signature}
                                        onChange={(e) => this._handleSignageChange('signature', e.target.value)}
                                        customInputStyle={ signatureStyle }
                                        error={ this.state.signageSignatureError }
                                    />

                                    <DateInput
                                        label={ i18n.t(tokens.labels.account.datedOnYYYYMMDD)}
                                        fullWidth
                                        value={this.state.signage.datedOn}
                                        onChange={(e) => this._handleSignageChange('datedOn', e.target.value)}
                                        error={ this.state.signageDatedOnError }
                                    />

                                    <FormGroup row style={{ marginTop: 20 }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={ this.state.signage.acceptedTerms }
                                                    onChange={ () => this._handleSignageChange('acceptedTerms', !this.state.signage.acceptedTerms) }
                                                    value="acceptedTerms"
                                                />
                                            }
                                            label={ i18n.t(tokens.labels.account.acknowledgeInfoAccuracy) }
                                        />
                                    </FormGroup>

                                    <Button
                                        onClick={this.state.dependentToRemoveID ? this._remove : this._save}
                                        marginTop={4}
                                        color="primary"
                                        fullWidth
                                    >
                                        { i18n.t(tokens.buttons.finish) }
                                    </Button>
                                </React.Fragment>
                        }

                        {
                            !this.state.ageDisclaimer && !this.state.confirmPasswordModalOpen &&
                                <React.Fragment>
                                    <TextInput
                                        label={ i18n.t(tokens.labels.firstname) }
                                        value={this.state.firstname}
                                        autoFocus
                                        onBlur={() => this._onBlur('firstname')}
                                        onChange={(value) => this._handleInputChange('firstname', value)}
                                        error={Boolean(this.state.firstnameError)}
                                        helperText={this.state.firstnameError}
                                        fullWidth
                                    />

                                    <TextInput
                                        label={ i18n.t(tokens.labels.lastname) }
                                        value={this.state.lastname}
                                        onBlur={() => this._onBlur('lastname')}
                                        onChange={(value) => this._handleInputChange('lastname', value)}
                                        error={Boolean(this.state.lastnameError)}
                                        helperText={this.state.lastnameError}
                                        fullWidth
                                    />

                                    <TextInput
                                        label={ i18n.t(tokens.labels.gender) }
                                        value={this.state.gender}
                                        fullWidth
                                        onBlur={() => this._onBlur('gender')}
                                        onChange={(value) => this._handleInputChange('gender', value)}
                                        error={Boolean(this.state.genderError)}
                                        helperText={this.state.genderError}
                                        select
                                        selectOptions={Services.selectFieldOptions.genderOptions()}
                                    />

                                    <DateInput
                                        label={ i18n.t(tokens.labels.account.dateOfBirthYYYYMMDD)}
                                        value={this.state.birthdate}
                                        onBlur={() => this._onBlur('birthdate')}
                                        onChange={(value) => this._handleInputChange('birthdate', value)}
                                        error={Boolean(this.state.birthdateError)}
                                        helperText={this.state.birthdateError}
                                        fullWidth
                                    />

                                    <TextInput
                                        label={ i18n.t(tokens.labels.relationship) }
                                        value={this.state.relationship}
                                        onBlur={() => this._onBlur('relationship')}
                                        onChange={(value) => this._handleSelectChange('relationship', value, this.state.dependentID)}
                                        error={Boolean(this.state.relationshipError)}
                                        helperText={this.state.relationshipError}
                                        select
                                        selectOptions={this.state.options}
                                        fullWidth
                                    />

                                    {
                                        this.state.relationship !== 'Common Law' &&
                                            <DateInput
                                                label={ i18n.t(tokens.labels.account.coHabDate) }
                                                value={this.state.cohabDate}
                                                onBlur={() => this._onBlur('cohabDate')}
                                                onChange={(value) => this._handleInputChange('cohabDate', value)}
                                                error={Boolean(this.state.cohabDateError)}
                                                helperText={this.state.cohabDateError}
                                                disabled={ this.state.isEdit }
                                                fullWidth
                                            />
                                    }

                                    <TextInput
                                        label={ i18n.t(tokens.labels.account.emailOptional) }
                                        value={this.state.email}
                                        onBlur={() => this._onBlur('email')}
                                        onChange={(value) => this._handleSelectChange('email', value, this.state.dependentID)}
                                        error={Boolean(this.state.emailError)}
                                        helperText={this.state.emailError}
                                        fullWidth
                                        disabled={true}
                                    />

                                    {
                                        this.state.relationship.toLowerCase() === 'spouse' &&
                                            <React.Fragment>
                                                <FormControl component="fieldset">
                                                    <Text
                                                        medium
                                                        light
                                                        margin="10px 0 10px 0"
                                                    >
                                                        Do you have additional coverage through your Spouse?
                                                    </Text>

                                                    <BubbleSelectBlock
                                                        first={{
                                                            title: 'Yes',
                                                            selected: Boolean(this.state.spouseCoverage) === true,
                                                            field: 'spouseCoverageYes'
                                                        }}
                                                        second={{
                                                            title: 'No',
                                                            selected: Boolean(this.state.spouseCoverage) === false,
                                                            field: 'spouseCoverageNo'
                                                        }}
                                                        onBlur={() => this._onBlur('spouseCoverage')}
                                                        handleChange={ async (field) => {
                                                            if (field === 'spouseCoverageYes') {
                                                                await this._handleInputChange('spouseCoverage', true, true);
                                                            } else {
                                                                await this._handleInputChange('spouseCoverage', false, true);
                                                            }
                                                        }}
                                                    />
                                                </FormControl>

                                                {
                                                    Boolean(this.state.spouseCoverage) === true &&
                                                    <React.Fragment>
                                                        <TextInput
                                                            label="Spouses Employer"
                                                            value={this.state.employer}
                                                            onBlur={() => this._onBlur('employer')}
                                                            onChange={(value) => this._handleInputChange('employer', value)}
                                                            fullWidth
                                                        />

                                                        <TextInput
                                                            label="Spouses Current Insurance Carrier"
                                                            value={this.state.insuranceCarrier}
                                                            fullWidth
                                                            onBlur={() => this._onBlur('insuranceCarrier')}
                                                            onChange={(value) => this._handleInputChange('insuranceCarrier', value)}
                                                            select={
                                                                (!this.state.insuranceCarrier || insuranceOptions.indexOf(this.state.insuranceCarrier) > -1)
                                                                && this.state.insuranceCarrier !== ''
                                                            }
                                                            selectOptions={insuranceOptions}
                                                        />

                                                        <TextInput
                                                            label="Certificate Number"
                                                            value={this.state.dependentCertNumber}
                                                            fullWidth
                                                            onBlur={() => this._onBlur('dependentCertNumber')}
                                                            onChange={(value) => this._handleInputChange('dependentCertNumber', value)}
                                                        />
                                                    </React.Fragment>
                                                }
                                            </React.Fragment>
                                    }

                                    <Button
                                        onClick={this._validateForm}
                                        marginTop={4}
                                        color="primary"
                                        fullWidth
                                    >
                                        Save Dependent
                                    </Button>
                                </React.Fragment>
                        }
                        {this.props.loading && <Loader whitelabel={ whitelabel } customImageStyle={{ top: '50%' }} noGif />}
                    </FormModal>
                </ContentSmall>
            </Container>
        );
    }
}

Dependents.propTypes = {
    loading: PropTypes.bool,
    dependents: PropTypes.array,
    whitelabel: PropTypes.object
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loading: state.user.loading,
    dependents: state.user.dependents,
    whitelabel: state.whitelabel
});

export default connect(mapStateToProps)(Dependents);